/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import classNames from 'classnames';
import Background from 'components/common/Background';
import SoftBadge from 'components/common/SoftBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CountUp from 'react-countup';
import bg1 from 'assets/img/icons/spot-illustrations/corner-1.png';
import bg2 from 'assets/img/icons/spot-illustrations/corner-2.png';
import bg3 from 'assets/img/icons/spot-illustrations/corner-4.png';
import bg4 from 'assets/img/icons/spot-illustrations/corner-10.png';
import bg5 from 'assets/img/icons/spot-illustrations/corner-8.png';
import bg6 from 'assets/img/icons/spot-illustrations/cornerGreen.png';
import bg7 from 'assets/img/icons/spot-illustrations/cornerPurple.png';

const CustomTooltip = ({ content }) =>
  content ? (
    <div
      style={{
        position: 'absolute',
        // top: position.top,
        // left: position.left,
        background: 'white',
        color: 'black',
        padding: '8px',
        borderRadius: '4px',
        zIndex: 1000, // Adjust the z-index as needed
        fontSize: '14px',
        maxWidth: '90%',
        borderColor: '#d3d3d3',
        border: '1px solid #d3d3d3',
        boxShadow: '1px 1px 5px rgba(0, 0, 0, 0.1)',
        lineHeight: '1.2'
      }}
      className="custom-tooltip"
    >
      <span style={{ fontSize: '12px' }}>{content}</span>
    </div>
  ) : (
    <></>
  );

const StatisticsCard = ({ stat, index, ...rest }) => {
  const { sign, value, info, title, suffix, desc } = stat;
  let valueClassName = 'text-warning';
  let badgeBg = 'warning';
  let className = '';
  let cardBackground = bg4;
  const decimal = true;
  if (sign === 'positive') {
    cardBackground = bg6;
    badgeBg = 'success';
    valueClassName = 'text-success';
  } else if (sign === 'neutral') {
    cardBackground = bg4;
    badgeBg = 'info';
    valueClassName = 'text-info';
  } else if (sign === 'negative') {
    cardBackground = bg7;
    badgeBg = 'warning';
    valueClassName = 'text-warning';
  } else if (sign === 'Excellent') {
    cardBackground = bg6;
    badgeBg = 'success';
    valueClassName = 'text-success';
  } else if (sign === 'Good') {
    cardBackground = bg7;
    badgeBg = 'success';
    valueClassName = 'text-success';
  } else if (sign === 'Average') {
    cardBackground = bg5;
    badgeBg = 'info';
    valueClassName = 'text-info';
  } else if (sign === 'Below Average') {
    cardBackground = bg6;
    badgeBg = 'warning';
    valueClassName = 'text-warning';
  } else if (sign === 'Poor') {
    cardBackground = bg5;
    badgeBg = 'danger';
    valueClassName = 'text-danger';
  } else if (sign === 'Very Poor') {
    cardBackground = bg4;
    badgeBg = 'danger';
    valueClassName = 'text-danger';
  }

  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const handleTitleHover = () => {
    setTooltipVisible(true);
  };

  const handleTitleLeave = () => {
    setTooltipVisible(false);
  };

  const formatIndianNumber = num => {
    // Split number into integer and decimal parts
    const [integerPart, decimalPart] = num.toString().split('.');

    const number = Math.floor(Number(integerPart));
    if (number < 1000) {
      // Return with decimal if it exists
      return decimalPart ? `${number}.${decimalPart}` : number.toString();
    }

    const str = number.toString();
    const lastThree = str.substring(str.length - 3);
    const otherNumbers = str.substring(0, str.length - 3);

    const lastThreeFormatted = otherNumbers.length
      ? `,${lastThree}`
      : lastThree;

    // Format remaining numbers in groups of 2
    const formatted = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

    // Add decimal part if it exists
    const finalNumber = `${formatted}${lastThreeFormatted}`;
    return decimalPart ? `${finalNumber}.${decimalPart}` : finalNumber;
  };
  // console.log(stat)
  return (
    <Card
      className={classNames(className)}
      {...rest}
      style={{ minHeight: '120px' }}
    >
      <Background image={cardBackground} className="bg-card" />
      <Card.Body className="position-relative gap-3">
        <h5
          style={{
            cursor: desc ? 'pointer' : '',
            width: 'fit-content',
            fontSize: '1rem'
          }}
          className="d-flex justify-content-center align-items-center mb-2"
        >
          {title}
          {/* {sign && (
            <SoftBadge bg={badgeBg} pill className="ms-2 card-badge-text">
              {sign}
            </SoftBadge>
          )} */}
        </h5>
        <div
          className={classNames(
            valueClassName,
            'display-4 fs-2 font-sans-serif card-fw-2'
          )}
        >
          <CountUp
            start={0}
            end={value}
            duration={2.75}
            separator=","
            decimals={value % 1 !== 0 ? 2 : 0} // Dynamically set decimals based on input
            formattingFn={formatIndianNumber}
          />
          {/* {value} */}
        </div>
      </Card.Body>
    </Card>
  );
};

StatisticsCard.propTypes = {
  stat: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    sign: PropTypes.string,
    info: PropTypes.string.isRequired
  })
};

export default StatisticsCard;
